import { PaymentStatus } from '@wix/wix-vod-constants/api-types';

export function isStatusSuccess(status) {
  return status === PaymentStatus.ACTIVE;
}

export function isStatusPending(status) {
  return status === PaymentStatus.PENDING;
}

export function isStatusCanceled(status) {
  return status === PaymentStatus.CANCELED;
}
